import { paths } from '@mc/paths'
import { trackPromoPageCtaClick } from './promoPageCtaClick'
import { trackPurchaseClick, type PurchaseClickProps } from './purchaseClick'

// Judged on the page the click happens on, never on the caller's `pageSource`
// override — five surfaces pass one, and the override names the page a CTA
// belongs to rather than the page it renders on.
const isOnPromotionPage = () =>
  typeof window !== 'undefined' && window.location.pathname === paths.promotion

/**
 * The purchase-funnel CTA event for middle-funnel CTAs — those that navigate to
 * quiz, quiz results, or checkout. Such CTAs should call ONLY this function.
 *
 * Fires "Purchase Click" with gold-standard delivery, so it reaches
 * PALM/Martech → Meta AddToCart.
 *
 * /promotion is a middle-funnel page: its CTAs fire "Promo Page Click"
 * instead, because the upper-funnel CTA that routed the user there already
 * fired the funnel-entry event.
 */
export const trackGoldStandardPurchaseClick = (props: PurchaseClickProps) => {
  if (isOnPromotionPage()) {
    trackPromoPageCtaClick({
      action: props.action,
      location: props.location,
      href: props.href,
      properties: props.purchaseClickProps,
    })
    return
  }

  trackPurchaseClick(props)
}
